export default __webpack_public_path__ + "static/media/home-icon.a794f7b5.svg";